import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

export const GoodbyeEventDetails = () => {
    const { t } = useTranslation();
    return (
        <Fragment>
            { t(`VIDEO.EVENT.GBYE_DETAIL`) }
        </Fragment>
    );
};
